import { instantsInterceptor, } from '@/api/index';

function getNoticeList(form) {
    return instantsInterceptor.post('/notice/list', form);
}

function getNoticeMgmtList(form) {
    return instantsInterceptor.post('/mgmt/notice/list', form);
}

function getNoticeMgmtDetail(boardId) {
    return instantsInterceptor.post('/mgmt/notice/detail', { boardId: boardId });
}

function getNotice(boardId) {
    return instantsInterceptor.get('/notice/detail/' + boardId);
}

function insertNotice(notice) {
    return instantsInterceptor.post('/mgmt/notice/save', notice);
}

function deleteNotice(notice) {
    return instantsInterceptor.post('/mgmt/notice/delete', notice);
}


export { getNoticeList, getNotice, insertNotice, getNoticeMgmtList, getNoticeMgmtDetail, deleteNotice };